import range from 'lodash/range';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';

import ENPSRatingItem from './ENPSRatingItem';
import { ENPSRatingProps } from './types';

export const DEFAULT_RATING_SIZE = 10;
const start = 0;
const step = 1;

const CONFIG = {
  medium: {
    gapX: 1,
    roundedStart: 'rounded-s-4',
    roundedEnd: 'rounded-e-4',
    item: 'h-40 body-short-03',
  },
  large: {
    gapX: 2,
    roundedStart: 'rounded-s-8',
    roundedEnd: 'rounded-e-8',
    item: 'h-48 body-short-02',
  },
};

const ENPSRating: React.FC<ENPSRatingProps> = (props) => {
  const {
    className,
    size = 'medium',
    value: valueProp,
    onChange,
    ratingScale = DEFAULT_RATING_SIZE,
  } = props;
  const { gapX, roundedStart, roundedEnd, item } = CONFIG[size];

  return (
    <Stack className={className} gapX={gapX}>
      {range(start, ratingScale + 1, step).map((value, index, array) => {
        const isFirst = index === 0;
        const isLast = index === array.length - 1;

        return (
          <ENPSRatingItem
            key={value}
            className={cn('flex-1', item, { [roundedStart]: isFirst, [roundedEnd]: isLast })}
            isSelected={valueProp === value}
            value={value}
            onClick={onChange}
          />
        );
      })}
    </Stack>
  );
};

export default ENPSRating;
